import React, { FC } from "react";
import { useTheme } from "styled-components";

type Props = {
  outline?: boolean;
};

export const Star: FC<Props> = ({ outline = false }) => {
  const theme = useTheme();

  if (outline) {
    return (
      <svg
        width="14"
        height="13"
        viewBox="0 0 14 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.00067 0.583496C7.22825 0.583496 7.43505 0.715848 7.53037 0.922502L9.1241 4.37771L12.9027 4.82572C13.1287 4.85251 13.3185 5.00829 13.3888 5.22473C13.4591 5.44118 13.3971 5.67875 13.2301 5.83327L10.4365 8.41671L11.178 12.1488C11.2224 12.372 11.1329 12.6006 10.9487 12.7344C10.7646 12.8682 10.5195 12.8827 10.3209 12.7715L7.00067 10.913L3.6804 12.7715C3.48181 12.8827 3.23671 12.8682 3.0526 12.7344C2.86848 12.6006 2.77897 12.372 2.82332 12.1488L3.56489 8.41671L0.771283 5.83327C0.604198 5.67875 0.542229 5.44118 0.612555 5.22473C0.682881 5.00829 0.872659 4.85251 1.09866 4.82572L4.87724 4.37771L6.47097 0.922502C6.56629 0.715848 6.77309 0.583496 7.00067 0.583496ZM7.00067 2.55954L5.66311 5.45937L2.49189 5.83537L4.83646 8.00356L4.21409 11.1358L7.00067 9.57595L9.78725 11.1358L9.16489 8.00356L11.5095 5.83537L8.33823 5.45937L7.00067 2.55954Z"
          fill={theme.colors.primary}
        />
      </svg>
    );
  }

  return (
    <svg
      width="12"
      height="11"
      viewBox="0 0 12 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6 0C6.2128 0 6.40617 0.118727 6.4953 0.304108L7.98554 3.40362L11.5188 3.80551C11.7301 3.82955 11.9075 3.96929 11.9733 4.16345C12.039 4.35761 11.9811 4.57073 11.8249 4.70934L9.21267 7.02684L9.90608 10.3747C9.94755 10.575 9.86385 10.7801 9.69169 10.9001C9.51953 11.0201 9.29035 11.033 9.10466 10.9333L6 9.26611L2.89534 10.9333C2.70965 11.033 2.48047 11.0201 2.30831 10.9001C2.13615 10.7801 2.05245 10.575 2.09392 10.3747L2.78733 7.02684L0.175136 4.70934C0.0189011 4.57073 -0.0390438 4.35761 0.0267152 4.16345C0.0924741 3.96929 0.269929 3.82955 0.481249 3.80551L4.01446 3.40362L5.5047 0.304108C5.59383 0.118727 5.7872 0 6 0Z"
        fill={theme.colors.primary}
      />
    </svg>
  );
};
